// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderSideBar_container__DGcOV","close":"HeaderSideBar_close__N2lGO","menu":"HeaderSideBar_menu__B8KVt"};